import { render } from "./ClientsUser.vue?vue&type=template&id=391fe317"
import script from "./ClientsUser.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientsUser.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script